import React from "react";
import { connect } from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";
import PropTypes from "prop-types";

import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import RemoveIcon from "@mui/icons-material/Remove";
import AddIcon from '@mui/icons-material/Add';

import {setGroheActiveFeatureQuantity} from "../../../../../actions/groheFunctions";
import {IS_PRODUCT_JOURNEY} from "../../../../../config";
import Analytics, {PRODUCT_JOURNEY_ANALYTIC_EVENTS} from "../../../../../analytics";
import {featureInterface} from "../../../../../interfaces/featureInterface";
import {getFeatureUnit} from "../../../../../misc/helpers";
import {pricingIsLocked} from "../../../lookNavigation/lookNavigationFunctions";

const GroheFeatureQuantity = (props) => {
  const {intl, isMobile, disabled, groheActiveFeatureQuantity, setGroheActiveFeatureQuantity, lookActiveFeature, feature,
    hideTitle, isWizard, fabricatorData} = props;
  const MAX = 99999;
  const MIN = isWizard ? 0 : 1;

  const allowDecimals = isWizard;

  const updateQuantity = (quan) => {
    setGroheActiveFeatureQuantity(quan);
  };

  const handleInputChange = (e, fromButton = "") => {
    let value = "" + e.target.value;

    if (value.includes(".")) {
      if (!allowDecimals) {
        return false
      }
      if (value.split(".")[1].length > 3) {
        value = +value.substring(0, value.length - 1); //round to 3 decimals
      }
    }

    const featureLabel = Analytics.getSkuForAnalytics(feature || lookActiveFeature);
    const analyticsAdjust = fromButton ? fromButton + "-" + value : "input-" + value;
    Analytics.sendClickEvent(`${PRODUCT_JOURNEY_ANALYTIC_EVENTS.productFeatureQuantityChange + featureLabel}-${analyticsAdjust}`);

    value = +value;

    if (value <= MIN) {
      value = MIN;
    } else if (value > MAX) {
      value = MAX;
    }

    updateQuantity(value);
  };

  const handleOnKeyDown = (event) => {
    if (event.key==='.' && !allowDecimals) {
      event.preventDefault();
      return false
    }
  };

  const {isLixil} = pricingIsLocked();

  return (
    <div className="grohe-quan">
      <div className={"grohe-quantity " + (disabled ? "grohe-quantity--disabled" : "")
        + (!IS_PRODUCT_JOURNEY ? "look-quantity" : "")} >
        {hideTitle ? null : (
          <div className="grohe-quantity__text">
            {isLixil
              ? <FormattedMessage id={isMobile || !IS_PRODUCT_JOURNEY ? "look.list.feature.quantity" : "grohe.feature.quantity"}/>
              : getFeatureUnit(feature || lookActiveFeature, intl, fabricatorData, groheActiveFeatureQuantity)}
          </div>
        )}
        <div className="grohe-quantity__container">
          <IconButton aria-label={intl.formatMessage({id:"look.list.header.printButton"})}
                      onClick={() => {
                        handleInputChange({target: {value: groheActiveFeatureQuantity - 1}}, "minus")
                      }}
                      disabled={disabled}
                      className={"look-icon grohe-look__icon--small"
                      + (isMobile || !IS_PRODUCT_JOURNEY ? " look-icon--tiny look-icon--semi" : " look-icon--small")}>
            <RemoveIcon />
          </IconButton>
          <TextField className={"grohe-quantity__input"}
                     label=""
                     //variant="standard"
                     disabled={disabled}
                     size="small"
                     type="number"
                     value={groheActiveFeatureQuantity}
                     pattern="^\d+(?:\.\d{1,2})?$"
                     onKeyDown={handleOnKeyDown}
                     onChange={handleInputChange}/>
          <IconButton aria-label={intl.formatMessage({id:"look.list.header.printButton"})}
                      onClick={() => {
                        handleInputChange({target: {value: groheActiveFeatureQuantity + 1}}, "plus")
                      }}
                      disabled={disabled}
                      className={"look-icon grohe-look__icon--small"
                      + (isMobile || !IS_PRODUCT_JOURNEY ? " look-icon--tiny look-icon--semi" : " look-icon--small")}>
            <AddIcon />
          </IconButton>
        </div>
      </div>
    </div>
  )
};

GroheFeatureQuantity.propTypes = {
  disabled: PropTypes.bool,
  hideTitle: PropTypes.bool,
  isWizard: PropTypes.bool,
  feature: PropTypes.shape(featureInterface)
};

const mapStateToProps = (store) => {
  const {isMobile} = store.serverState;
  const {groheActiveFeatureQuantity} = store.groheState;
  const {lookActiveFeature} = store.lookState;
  const fabricatorData = store.fabricatorState;

  return {
    isMobile,
    groheActiveFeatureQuantity,
    lookActiveFeature,
    fabricatorData,
  }
};

const mapDispatchToProps = {
  setGroheActiveFeatureQuantity
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(GroheFeatureQuantity)
)
